import axios from "axios";

import { getAllRoles } from "../RoleManagement/services";

export function makeRequestForUserPermissions(payload: object) {
  return axios("api/Users/permissions", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(payload),
  });
}

export function getAttendeeNotificationInformation(attendeeId: number) {
  return axios(`api/Users/getAttendeeNotificationInformation/${attendeeId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
}

function fetchAllUsers() {
  return axios(`api/Users/AllUsers`, {
    method: "GET",
  });
}

export function fetchAllUsersAndRoles() {
  return axios.all([fetchAllUsers(), getAllRoles()]);
}

export function getUser(userId: number) {
  return axios(`api/Users/UsersRecordIncludingPermissions/${userId}`, {
    method: "GET",
  });
}
